/* eslint-disable @repo/internal/react/require-jsdoc */
import { createContext } from 'react';
export const ModalContext = /*#__PURE__*/createContext(null);
export const ScrollContext = /*#__PURE__*/createContext(null);